import { useSelector } from "react-redux";
import { wrapper } from "../../redux";
import { fetchBrands } from "../../redux/action-creaters/brands";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import styles from "./index.module.scss";
import Redis from "/lib/redis";
import SectionsTree from "../../components/pages/sections/sectionsTree";
import CatalogSide from "../../components/layouts/catalogSide";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function BrandsPage({ scripts, host }) {
  const { items } = useSelector((state) => state.brands);
  return (
    <LayoutWrapper scripts={scripts} isIndex={false} host={host}>
      <CatalogSide side={<SectionsTree sectionId={999}></SectionsTree>}>
        <div>
          <h1>Бренды</h1>
          <div className={styles.Items}>
            {items.map((item) => (
              <a
                key={item.name}
                data-test="contentListItem"
                href={item.detalPageUrl}
              >
                <div>
                  <img
                    src={item.pictureSrc}
                    alt={item.name}
                    title={item.name}
                  />
                </div>
                <span>{item.name}</span>
              </a>
            ))}
          </div>
        </div>
      </CatalogSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ query, req, resolvedUrl }) => {
    const reset = Boolean(query.reset);
    await store.dispatch(await fetchBrands(Redis, reset));
    store.dispatch(addBreadcrumb({ link: "/brands/", name: "Бренды" }));

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.brandsList },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/brands/",
    );
  }),
);
